<template>
    <div>
        <div class="btn-tip-wrap flex">
            <span>「主管理员」可以添加「子管理员」，且同时拥有人事管理全部功能权限</span>
            <el-button type="primary" @click="handleClickManagerAdd">添加管理员</el-button>
        </div>
        <CustomVxeTable id="customTable1" ref="customTable" :tableData="tableData" :reduceHeight="170" :showPagination="false">
            <vxe-column field="name" title="管理员" min-width="363" show-overflow>
                <template #default="{ row }">
                    <el-popover placement="bottom-start" :visible-arrow="false" popper-class="user_card_popper" trigger="hover" width="282">
                        <template slot="reference">
                            <div class="user-avatar-tag">
                                <img src="https://img.js.design/assets/img/669f4a8b243bddd89fb3d836.jpg" alt="">
                                <span>{{ row.name }}</span>
                            </div>
                        </template>
                        <PersonnelCard :userInfo="currentUserInfo" />
                    </el-popover>
                    <el-tooltip class="item" effect="dark" content="主管理员" placement="top-start">
                        <i class="iconfont icon-bumenfuzeren user-level-icon"></i>
                    </el-tooltip>
                </template>
            </vxe-column>
            <vxe-column field="dTitle" title="部门" min-width="320" show-overflow>
            </vxe-column>
            <vxe-column field="createTime" title="最近编辑授权时间" min-width="517" show-overflow>
            </vxe-column>
            <vxe-column field="operate" title="操作" width="54px" fixed="right" :show-overflow="false">
                <template #default="{ row }">
                    <el-button type="text" class="warn-text" @click="handleClickRemove(row)" disabled>移除</el-button>
                </template>
            </vxe-column>
        </CustomVxeTable>
        <ManagerAdd ref="ManagerAdd" :managerAddDialog.sync="managerAddDialog" v-if="managerAddDialog" />
        <el-dialog title="" v-if="deletePersonelDialog" :visible.sync="deletePersonelDialog" width="390px" :before-close="handleDeletePersonelDialogClose" :close-on-click-modal="false"
            class="custom-dialog custom-tooltip-confirm-dialog">
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">
                        确定要移除该人员吗？
                    </p>
                    <p>移除后，该人员将无法管理该模块，模块内功能可能也无法使用！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleDeletePersonelDialogClose">取消</el-button>
                <el-button type="danger" @click="handleDeletePersonelDialogConfirm">移除</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import CustomVxeTable from "@/components/pComponents/vxe-table";
import ManagerAdd from "./component/manager_add.vue"
import PersonnelCard from "@/components/pComponents/PersonnelCard.vue";
export default {
    name: "PersonnelManager",
    components: { CustomVxeTable, ManagerAdd, PersonnelCard},
    data() {
        return {
            tableData: [
                {
                    name: "张三",
                    dTitle: "人事行政部",
                    createTime: "2024-09-20 15:30"
                }
            ],
            managerAddDialog: false,
            deletePersonelDialog: false,
            currentUserInfo: {}
        }
    },
    methods: {
        handleClickManagerAdd() {
            this.managerAddDialog = true
        },
        handleClickRemove(row) {
            this.deletePersonelDialog = true
        },
        // 移除
        handleDeletePersonelDialogClose() {
            this.deletePersonelDialog = false
        },
        handleDeletePersonelDialogConfirm() {
            this.deletePersonelDialog = false
        },
    }
}
</script>
<style lang="scss" scoped>
.user-level-icon {
    width: 22px;
    height: 22px;
    border-radius: 4px;
    display: inline-block;
    text-align: center;
    line-height: 22px;
    vertical-align: middle;
    font-size: 16px;
    color: #F0AA32;
    cursor: pointer;
    &:hover {
        background-color: rgba(0, 0, 0, 0.04);
    }
}
.btn-tip-wrap {
    justify-content: space-between;

    span {
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
    }

    .el-button {
        padding: 8px 15px;
    }
}
</style>
